import { Injectable, inject } from "@angular/core";
import remove from "lodash/remove";
import { BehaviorSubject, Observable } from "rxjs";
import { WebinstallningarService } from "~app/common/services/webinstallningar/webinstallningar.service";
import { INamedSokfilter } from "./models/named-sokfilter";
import { ISparadeSokfilter } from "./models/sparade-sokfilter";

@Injectable({
    providedIn: "root"
})

export class ArbetsorderSearchMinaFilterService {
    private readonly webinstallningarService = inject(WebinstallningarService);

    get minaSparadeFilter(): Observable<INamedSokfilter[]> {
        return this.minaSokfilter$.asObservable();
    }

    private readonly WIK = "Planera.filter.sparade";
    private readonly maxSavedFilters = 25;
    private readonly minaSokfilter$: BehaviorSubject<INamedSokfilter[]> = new BehaviorSubject<INamedSokfilter[]>([]);

    constructor() {
        this.getInstallningar();
    }

    getInstallningar() {
        this.webinstallningarService
            .getAsync(this.WIK)
            .then((value: ISparadeSokfilter) => {
                if (value && value.minaFilter) {
                    this.minaSokfilter$.next(value.minaFilter);
                }
            });
    }

    nameIsUnique(filter: INamedSokfilter) {
        return !this.minaSokfilter$.value || !this.minaSokfilter$.value.some(x => x.namn.toLowerCase().trim() === filter.namn.toLowerCase().trim());
    }

    saveLimitReached() {
        // Max 5 filter till att börja med, fler kräver scrollning eller annan presentation av sparade filter.
        return this.minaSokfilter$.value && this.minaSokfilter$.value.length >= this.maxSavedFilters;
    }

    saveSearchFilter(namedSearchFilter: INamedSokfilter) {
        this.webinstallningarService
            .setAsync(this.WIK, {
                minaFilter: [
                    ...this.minaSokfilter$.value,
                    ...[namedSearchFilter]
                ]
            })
            .then((result) => {
                this.getInstallningar();
            });
    }

    updateSearchFilterByNamn(namedSearchFilter: INamedSokfilter) {
        remove(this.minaSokfilter$.value, f => this.isEqualIgnoreCaseAndWhitespace(f.namn, namedSearchFilter.namn));
        this.saveSearchFilter(namedSearchFilter);
    }

    deleteSearchFilterByNamn(namn: string) {
        remove(this.minaSokfilter$.value, f => this.isEqualIgnoreCaseAndWhitespace(f.namn, namn));

        this.webinstallningarService
            .setAsync(this.WIK, {
                minaFilter: this.minaSokfilter$.value
            })
            .then((result) => {
                this.getInstallningar();
            });
    }

    private isEqualIgnoreCaseAndWhitespace(a: string, b: string): boolean {
        return a.trim().toLowerCase() === b.trim().toLowerCase();
    }
}
